import { exerciseApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';
import { CreateExerciseDTO, UpdateExerciseDTO } from '@/generated';

const refreshChannel = new BroadcastChannel('exercise-refresh');

export const useDeleteExercise = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (exerciseId: string) => exerciseApi.exerciseDelete({ exerciseId: exerciseId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.AllExercises] });
      //TODO: Update regression on delete
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useUpdateExercise = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updateExerciseDTO: UpdateExerciseDTO) => exerciseApi.exerciseUpdate({ updateExerciseDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.AllExercises] });
      queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, dto.id] });
      dto.regressionExerciseIds.forEach((id) => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, id] });
      });
      dto.progressionExerciseIds.forEach((id) => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, id] });
      });
      dto.supportExercises.forEach((supportExercise) => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, supportExercise.exerciseId] });
      });
      dto.prerequisites.forEach((prerequisite) => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, prerequisite.exerciseId] });
      });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useCreateExercise = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createExerciseDTO: CreateExerciseDTO) => exerciseApi.exerciseCreate({ createExerciseDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.AllExercises] });
      dto.regressionExerciseIds.forEach((id) => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, id] });
      });
      dto.progressionExerciseIds.forEach((id) => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, id] });
      });
      dto.supportExercises.forEach((supportExercise) => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, supportExercise.exerciseId] });
      });
      dto.prerequisites.forEach((prerequisite) => {
        queryClient.invalidateQueries({ queryKey: [queryKeys.Exercise, prerequisite.exerciseId] });
      });
      refreshChannel.postMessage('refresh');
    },
  });
};
